import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { IsfV1ShipmentModel } from '@data-layer/models/isf-v1';
import { ShipmentModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class ShipmentsRepository {
  constructor(private apiService: ApiService) {}

  public get(shipmentId: number): Observable<IsfV1ShipmentModel> {
    return this.apiService.get(`${environment.url.shipment}${shipmentId}`);
  }

  public create(shipment: IsfV1ShipmentModel): Observable<IsfV1ShipmentModel> {
    return this.apiService.post(environment.url.shipment, shipment);
  }

  public update(shipmentId: number, shipment: IsfV1ShipmentModel): Observable<IsfV1ShipmentModel> {
    return this.apiService.put(`${environment.url.shipment}${shipmentId}`, shipment);
  }

  public updateFull(shipmentId: number, shipment: ShipmentModel, isShowLoader: boolean = true): Observable<ShipmentModel> {
    return this.apiService.put(`${environment.url.prefixCustoms}v2/shipments/${shipmentId}`, shipment, null, { isShowLoader });
  }
}
